import React from "react";
import { RoundedButton } from "@bloomberg/media-ui-core";
import { Tune } from "@bloomberg/media-ui-icons";

import styles from "./hideButton.module.css";

type HideButtonProps = {
  onClick: () => void;
};

export const HideButton = ({ onClick }: HideButtonProps) => {
  return (
    <RoundedButton
      appearance="outline"
      size="small"
      iconPosition="right"
      colorMode="light"
      className={styles.hideButton}
      onClick={onClick}
      version="phoenix"
    >
      <Tune />
    </RoundedButton>
  );
};
